module.exports = __webpack_public_path__ + "img/brands-vab.869f9bfc.svg";